{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Нове повідомлення",
  "chat.scrollToBottom": "Прокрутіть вниз",
  "messagefeedback.thumbDown": "Погана відповідь",
  "messagefeedback.thumbUp": "Гарна відповідь",
  "promptfield.aiDisclaimer": "Відповіді генеруються за допомогою ШІ і можуть бути неточними. Перевірте перед використанням.",
  "promptfield.aiUserGuidlines": "Керівництва користувача ШІ",
  "promptfield.attachments": "Додатки",
  "promptfield.insertButton": "Додати",
  "promptfield.label": "Підказка",
  "promptfield.placeholder": "Готові розпочати? Задайте запитання, поділіться ідеєю або додайте завдання.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Стоп",
  "promptfield.submitButton": "Відправити",
  "promptfield.uploading": "Завантаження",
  "responsestatus.loading": "Завантаження",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Починайте запис",
  "voicebutton.stopListening": "Припиніть запис",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
